import React from 'react'
import PropTypes from 'prop-types'
import {
  Field,
  Indicator,
  LocalizedDuration,
  LocalizedNumber,
  LocalizedText,
  Measure,
  Columns,
  ClockIcon,
} from 'labguard-cdk'
import ThresholdInput from '../ThresholdInput'
import ThresholdDurationInput from '../ThresholdDurationInput'

const ThresholdIndicator = ({
  icon,
  color,
  thresholdFieldName,
  delayFieldName,
  i18n,
  limit,
  unit,
  tempo,
  editable,
  disabled,
  autoFocus,
  onChange,
  ...props
}) => (
  <Indicator
    icon={icon}
    separator
    title={
      <Columns align="center">
        <Measure unit={unit} color={color}>
          {editable ? (
            <Field
              type="number"
              name={thresholdFieldName}
              component={ThresholdInput}
              onChange={onChange}
              step={0.5}
              color={color}
              disabled={disabled}
              autoFocus={autoFocus}
            />
          ) : (
            <LocalizedNumber value={limit} />
          )}
        </Measure>
        {delayFieldName && (
          <Measure icon={ClockIcon} color={color}>
            {editable ? (
              <Field
                type="number"
                name={delayFieldName}
                component={ThresholdDurationInput}
                onChange={onChange}
                min={0}
                step={1}
                color={color}
                disabled={disabled}
              />
            ) : (
              <LocalizedDuration value={tempo} />
            )}
          </Measure>
        )}
      </Columns>
    }
    subtitle={<LocalizedText id={i18n} />}
    color={color}
    height="1.875rem"
    {...props}
  />
)

ThresholdIndicator.propTypes = {
  icon: PropTypes.any,
  color: PropTypes.string,
  thresholdFieldName: PropTypes.string,
  delayFieldName: PropTypes.string,
  i18n: PropTypes.string,
  limit: PropTypes.number,
  unit: PropTypes.node,
  tempo: PropTypes.number,
  editable: PropTypes.bool,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  onChange: PropTypes.func,
}

export default React.memo(ThresholdIndicator)
